import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Form, message } from "antd";
import "./maintitle.css";
import {
  getMainTitleSettings,
  updateMainTitleSettings,
} from "../services/mainTitleSettingsService";

function MainTitle() {
  const [open, setOpen] = useState(true);
  const [id, setId] = useState(null);

  const [formData, setFormData] = useState({
    title1: "",
    title2: "",
    title3: "",
    title4: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await getMainTitleSettings();

      const data = res.data.data[0];

      setFormData({
        title1: data.title1,
        title2: data.title2,
        title3: data.title3,
        title4: data.title4,
      });

      setId(data.id);
    } catch (error) {
      message.error("Failed to load data");
    }
  };

const handleChange = (e) => {
  const { name, value } = e.target;

  const words = value.trim().split(/\s+/);

  if (words.length <= 10) {
    setFormData({
      ...formData,
      [name]: value,
    });
  } else {
    message.warning("Max 10 words allowed");
  }
};

  const handleUpdate = async () => {
    try {
      if (!id) return message.error("ID not found");

      await updateMainTitleSettings(id, formData);

      message.success("Updated Successfully ");
    } catch (error) {
      message.error("Update Failed ");
    }
  };

  return (
    <Modal
      title="Add Main Titles"
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      className="custom-modal"
    >
      <Form layout="vertical">
        <Form.Item label="Title 1" required>
          <Input
            placeholder="Enter title 1"
            name="title1"
            value={formData.title1}
            onChange={handleChange}
              maxLength={10}
          />
        </Form.Item>

        <Form.Item label="Title 2" required>
          <Input
            placeholder="Enter title 2"
            name="title2"
            value={formData.title2}
            onChange={handleChange}
              maxLength={10}
          />
        </Form.Item>

        <Form.Item label="Title 3" required>
          <Input
            placeholder="Enter title 3"
            name="title3"
            value={formData.title3}
            onChange={handleChange}
              maxLength={10}
          />
        </Form.Item>

        <Form.Item label="Title 4" required>
          <Input
            placeholder="Enter title 4"
            name="title4"
            value={formData.title4}
            onChange={handleChange}
              maxLength={10}
          />
        </Form.Item>

        <Button type="primary" block onClick={handleUpdate}>
          Update
        </Button>
      </Form>
    </Modal>
  );
}

export default MainTitle;
